//import axios from 'axios';
import axios from './axiosService.js';
import { Buffer } from 'buffer';

export const authService = {
    login,
	logout,
	getProfile,
	switchUser,
	switchUserLogout,
	refreshToken
};

function login(userName, password) {
	let config = {
		headers: {
		  'Content-type': "application/x-www-form-urlencoded",
		  'Authorization':'Basic ' + Buffer.from("public-client" + ":" + "ecl2020").toString('base64'),
		  'Accept': "application/json"
		},
		params: {
			grant_type: 'password',
			username: userName,
			password: password
		}
	}
	let body = {}
	//return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/oauth/token?grant_type=password&username="+userName+"&password="+password, body, config);
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/oauth/token", body, config);
}

function logout() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/logout", {params: {}});
}

function refreshToken(refresh_token) {
//	console.log("AuthService.refreshToken()");
	let config = {
		headers: {
		  'Content-type': "application/x-www-form-urlencoded",
		  'Authorization':'Basic ' + Buffer.from("public-client" + ":" + "ecl2020").toString('base64'),
		  'Accept': "application/json"
		},
		 params: {
			grant_type: 'refresh_token',
			refresh_token: refresh_token
		}
	}
	//console.log("refreshToken("+refresh_token+")");
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/oauth/token", null, config);
}
function switchUser(userName) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/switchuser/"+userName+"/", {params: {}});
}
function switchUserLogout() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/switchuser/logout/", {params: {}});
}
function getProfile() {
//	let config = {
//		 params: {
//		}
//	}
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/profile/", {params: {}});
}

function getUser(userId) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/"+userId+"/", {params: {}});
}
